module.exports = __webpack_public_path__ + "static/img/2.24fc21a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cs/2.jpg
// module id = fvZG
// module chunks = 1